module.exports = __webpack_public_path__ + "static/media/21ECLAC27.53cf0555.jpg";